import clients from "../../../fakeApi/clients";
const state = { clients: [] };

const getters = {
  allClients: state => state.clients.data
};
const actions = {
  async fetchClients({ commit }) {
    commit("setClients", clients);
  }
};

const mutations = {
  setClients: (state, clients) => (state.clients = clients)
};

export default {
  state,
  getters,
  actions,
  mutations
};
